/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  CurveRegistriesPoolsManagement,
  CurveRegistriesPoolsManagementInterface,
} from "../CurveRegistriesPoolsManagement";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "pool",
        type: "address",
      },
    ],
    name: "AlreadyRegistered",
    type: "error",
  },
  {
    inputs: [],
    name: "CantResolvePoolInRegistry",
    type: "error",
  },
  {
    inputs: [],
    name: "EmptyAddressProvider",
    type: "error",
  },
  {
    inputs: [],
    name: "EmptyPoolAddress",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidPriceProviderRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "pool",
        type: "address",
      },
    ],
    name: "PoolIsNotRegistered",
    type: "error",
  },
  {
    inputs: [],
    name: "RegistryIsTheSame",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "enum RegistryId",
        name: "id",
        type: "uint8",
      },
    ],
    name: "RegistryNotFoundById",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "contract ICurveAddressProviderLike",
        name: "curveAddressProvider",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum RegistryId",
        name: "registryId",
        type: "uint8",
      },
    ],
    name: "DataFetcherCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_pool",
        type: "address",
      },
    ],
    name: "PoolAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_pool",
        type: "address",
      },
    ],
    name: "PoolRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "registry",
        type: "address",
      },
    ],
    name: "RegistryUpdated",
    type: "event",
  },
  {
    inputs: [],
    name: "ADDRESS_PROVIDER",
    outputs: [
      {
        internalType: "contract ICurveAddressProviderLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REGISTRY_ID",
    outputs: [
      {
        internalType: "enum RegistryId",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isMeta",
            type: "bool",
          },
        ],
        internalType: "struct Pool[]",
        name: "_pools",
        type: "tuple[]",
      },
    ],
    name: "addPools",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "curveLPTokensDetailsFetcherPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_lpToken",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "getLPTokenDetails",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address",
              },
              {
                internalType: "bool",
                name: "isMeta",
                type: "bool",
              },
            ],
            internalType: "struct Pool",
            name: "pool",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "coins",
            type: "address[]",
          },
        ],
        internalType: "struct LPTokenDetails",
        name: "details",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "registeredPools",
    outputs: [
      {
        internalType: "bool",
        name: "isRegistered",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isMeta",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "registry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_pools",
        type: "address[]",
      },
    ],
    name: "removePools",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class CurveRegistriesPoolsManagement__factory {
  static readonly abi = _abi;
  static createInterface(): CurveRegistriesPoolsManagementInterface {
    return new utils.Interface(_abi) as CurveRegistriesPoolsManagementInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): CurveRegistriesPoolsManagement {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as CurveRegistriesPoolsManagement;
  }
}
